module.exports = __webpack_public_path__ + "static/media/gb-flag.4f1b7af5.svg";